import type { Message } from "@ag-ui/core";
import type { ReviewStatus } from "admin/types/interfaces/conversation";
import type { ConversationAgentSummary } from "~/services/agents";
import { apiClient, ApiError, isApiError } from "~/utils/apiClient";

const { VITE_ANALYSIS_AGENT_API } = import.meta.env;

export const adminConversationApiPath = (conversationId: string) =>
  `${VITE_ANALYSIS_AGENT_API}/admin/conversations/${conversationId}`;

export interface AdminConversationView {
  id: string;
  display_name: string;
  owner_display_name: string | null;
  created_at: string;
  review_status: ReviewStatus;
  messages: Message[];
  // The conversation's current agent (the agent of its latest turn that names
  // one), for labeling assistant turns. Null while no turn names an agent.
  agent: ConversationAgentSummary | null;
}

export async function getAdminConversation(
  conversationId: string,
  options?: { signal?: AbortSignal }
): Promise<AdminConversationView | null> {
  try {
    return await apiClient<AdminConversationView>(adminConversationApiPath(conversationId), {
      signal: options?.signal,
    });
  } catch (err) {
    if (isApiError(err) && (err as ApiError).status === 404) return null;
    throw err;
  }
}
